<admin-header [title]="title" (eventFired)="headerButtonClick($event)"></admin-header>
<div id="filters">
	<dx-button icon="fal fa-sync-alt" (onClick)="getData()" stylingMode="text" style="margin-right:auto"></dx-button>
	<dx-select-box [(value)]="selectedSiteId" [items]="sites" displayExpr="name" valueExpr="id" placeholder="All Sites" [showClearButton]="true" (onValueChanged)="changeSite($event)" style="width:180px; display:inline-block; margin-right:8px"></dx-select-box>
	<span class="view-toggles">
		<button [class.active]="period === '7'" (click)="changePeriod('7')">7 Days</button>
		<button [class.active]="period === '30'" (click)="changePeriod('30')">30 Days</button>
		<button [class.active]="period === 'both'" (click)="changePeriod('both')">Compare</button>
	</span>
</div>

<div *ngIf="isLoading" class="loading-overlay"><div class="spinner"></div></div>

<div class="dashboard-body">
	<!-- Summary Cards -->
	<div class="summary-cards">
		<div class="summary-card">
			<div class="card-label">Total Requests</div>
			<div class="card-value" *ngIf="period !== 'both'">{{ period === '7' ? summaryCards.count7 : summaryCards.count30 }}</div>
			<div class="card-compare" *ngIf="period === 'both'">
				<span class="compare-block"><small>7d</small> {{ summaryCards.count7 }}</span>
				<span class="compare-block"><small>30d</small> {{ summaryCards.count30 }}</span>
			</div>
		</div>
		<div class="summary-card">
			<div class="card-label">Avg Time to Arrival</div>
			<div class="card-value" *ngIf="period !== 'both'">{{ period === '7' ? summaryCards.avgArrival7 : summaryCards.avgArrival30 }} <small>mins</small></div>
			<div class="card-compare" *ngIf="period === 'both'">
				<span class="compare-block"><small>7d</small> {{ summaryCards.avgArrival7 }}m</span>
				<span class="compare-block"><small>30d</small> {{ summaryCards.avgArrival30 }}m</span>
			</div>
		</div>
		<div class="summary-card">
			<div class="card-label">Avg Time to Close</div>
			<div class="card-value" *ngIf="period !== 'both'">{{ period === '7' ? summaryCards.avgClose7 : summaryCards.avgClose30 }} <small>mins</small></div>
			<div class="card-compare" *ngIf="period === 'both'">
				<span class="compare-block"><small>7d</small> {{ summaryCards.avgClose7 }}m</span>
				<span class="compare-block"><small>30d</small> {{ summaryCards.avgClose30 }}m</span>
			</div>
		</div>
		<div class="summary-card accent">
			<div class="card-label">Currently Open</div>
			<div class="card-value">{{ summaryCards.openCount }}</div>
		</div>
	</div>

	<!-- Supervisor League Table -->
	<div class="section">
		<h3>Supervisor League Table</h3>
		<table class="perf-table">
			<thead><tr><th>Supervisor</th><th>Requests Closed</th><th>Avg Arrival (mins)</th><th>Avg Close (mins)</th></tr></thead>
			<tbody>
				<tr *ngFor="let s of supervisorLeague; let i = index">
					<td><strong>{{ i + 1 }}.</strong> {{ s.name }}</td>
					<td>{{ s.count }}</td>
					<td [class]="getTimeClass(s.avgArrival)">{{ s.avgArrival }}</td>
					<td [class]="getTimeClass(s.avgClose)">{{ s.avgClose }}</td>
				</tr>
				<tr *ngIf="supervisorLeague.length === 0"><td colspan="4" class="empty">No data for this period</td></tr>
			</tbody>
		</table>
	</div>

	<div class="two-col">
		<!-- Requests by Reason -->
		<div class="section">
			<h3>Requests by Reason</h3>
			<table class="perf-table">
				<thead><tr><th>Reason</th><th>Count</th></tr></thead>
				<tbody>
					<tr *ngFor="let r of byReason">
						<td>{{ r.reason }}</td>
						<td><strong>{{ r.count }}</strong></td>
					</tr>
					<tr *ngIf="byReason.length === 0"><td colspan="2" class="empty">No data</td></tr>
				</tbody>
			</table>
		</div>

		<!-- Requests by Machine -->
		<div class="section">
			<h3>Requests by Machine</h3>
			<table class="perf-table">
				<thead><tr><th>Machine</th><th>Count</th><th>Avg Arrival (mins)</th></tr></thead>
				<tbody>
					<tr *ngFor="let m of byMachine">
						<td>{{ m.name }}</td>
						<td><strong>{{ m.count }}</strong></td>
						<td [class]="getTimeClass(m.avgArrival)">{{ m.avgArrival }}</td>
					</tr>
					<tr *ngIf="byMachine.length === 0"><td colspan="3" class="empty">No data</td></tr>
				</tbody>
			</table>
		</div>
	</div>

	<!-- Recent Requests Grid -->
	<div class="section">
		<h3>All Requests ({{ filteredRequests.length }})</h3>
		<dx-data-grid [dataSource]="filteredRequests" [remoteOperations]="false" [allowColumnReordering]="true" [allowColumnResizing]="true" [rowAlternationEnabled]="true" [showBorders]="true">
			<dxo-paging [pageSize]="25"></dxo-paging>
			<dxo-pager [visible]="true" [showPageSizeSelector]="true" [allowedPageSizes]="[10, 25, 50, 100]"></dxo-pager>
			<dxo-search-panel [visible]="true"></dxo-search-panel>
			<dxi-column dataField="requestOpened" caption="Date" dataType="date" format="dd/MM/yyyy HH:mm" sortOrder="desc"></dxi-column>
			<dxi-column dataField="machine.cellNumber" caption="Machine"></dxi-column>
			<dxi-column dataField="supervisorRequestReason.reason" caption="Reason"></dxi-column>
			<dxi-column dataField="operator.firstName" caption="Operator" [calculateCellValue]="getOperatorName"></dxi-column>
			<dxi-column dataField="closingSupervisor.firstName" caption="Supervisor" [calculateCellValue]="getSupervisorName"></dxi-column>
			<dxi-column dataField="timeToArrival" caption="Arrival (hrs)" dataType="number" format="#0.##"></dxi-column>
			<dxi-column dataField="timeOpen" caption="Time Open (hrs)" dataType="number" format="#0.##"></dxi-column>
			<dxi-column dataField="closingComments" caption="Comments"></dxi-column>
		</dx-data-grid>
	</div>
</div>
